import React from 'react'

export default class WeekTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tableVisible: false,
        }
    }
    toggleTable = () => {
        this.setState({
            tableVisible: !this.state.tableVisible
        })
    }
    renderZarzamora = (harvestActivities) => {
        return (
            <>
            <div className="tabla">
                <h4>Pisca Zarzamora</h4>
                <table><tbody>
                    <tr>
                        <th>Fecha</th>
                        <th>Variedad</th>
                        <th>Sector</th>
                        <th>Medios Botes</th>
                    </tr>
                    {harvestActivities.map((activity, key) =>
                        <tr key={key}>
                            <td>{activity.fecha}</td>
                            <td>{activity.variedad}</td>
                            <td>{activity.sector}</td>
                            <td>{activity.totalCajas*4}</td>
                        </tr>
                    )}
                </tbody></table>
            </div>
            </>
        )
    }
    renderFrambuesa = (activities) => {
        return (
            <>
                <div className="tabla">
                <h4>Pisca Frambuesa</h4>
                <table><tbody>
                    <tr>
                        <th>Fecha</th>
                        <th>Variedad</th>
                        <th>Sector</th>
                        <th>Botes</th>
                    </tr>
                    {activities.map((activity, key) =>
                        <tr key={key}>
                            <td>{activity.fecha}</td>
                            <td>{activity.variedad}</td>
                            <td>{activity.sector}</td>
                            <td>{activity.totalBotes}</td>
                        </tr>
                    )}
                </tbody></table>
                </div>
            </>
        )
    }
    render() {
        return (
            <section>
                <div className='divrowH' onClick={this.toggleTable}>
                    <p>{`Semana ${this.props.week.weekAndYear}`}</p>
                    <p>{`Total de ${this.props.week.unidades}: ${this.props.week.total.toFixed(1)}`}</p>
                </div>
                {
                    this.state.tableVisible
                        ? this.props.week.activities.length > 0
                            ? this.renderFrambuesa(this.props.week.activities)
                            : null
                        : null
                }
                {
                    this.state.tableVisible
                        ? this.props.week.harvestActivities.length > 0
                            ? this.renderZarzamora(this.props.week.harvestActivities)
                            : null
                        : null
                }
            </section>
        )
    }
}
